/* RESPONSIBLE TEAM: team-inbox-management */
import type Workspace from 'embercom/objects/workspace';

/**
 * Determines if an entity should route to the AI automation page instead of admin profile.
 *
 * An entity should route to automation if:
 * 1. The inbox-fin-part-ai-agent-identity feature flag is enabled
 * 2. The entity is marked as an operator (AI agent identity or Fin operator)
 *
 * @param workspace - The current workspace to check feature flags
 * @param entity - The entity object that may have an isOperator property
 * @returns true if should route to automation, false if should route to admin profile
 */
export function shouldRouteToAutomation(workspace: Workspace, entity: unknown): boolean {
  if (!workspace.canUseFeature('inbox-fin-part-ai-agent-identity')) {
    return false;
  }

  // Type guard: check if entity has isOperator property
  if (typeof entity === 'object' && entity !== null && 'isOperator' in entity) {
    let entityWithOperator = entity as { isOperator?: boolean };
    return entityWithOperator.isOperator ?? false;
  }

  return false;
}
